import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';

const API_ORIGIN = process.env.NODE_ENV === 'production'
  ? ''
  : (process.env.REACT_APP_API_URL || 'http://localhost:3001/api/v1').replace(/\/api\/v1$/, '');

// Card único e padrão para toda enquete listada na página inicial — sem
// ícones. Se a enquete tiver imagem de capa, ela vira o fundo do card com
// uma camada branca bem transparente por cima (só o suficiente pra manter
// título/descrição legíveis rapidamente); sem imagem, fundo branco comum.
//
// Capa mobile é opcional e por cima da de desktop, alternando via classe
// responsiva (sm:hidden / hidden sm:block) — não dá pra trocar o
// background-image de um único elemento com media query inline, por isso
// dois elementos empilhados em vez de um só. Sem capa mobile, a camada de
// desktop fica sempre visível (sem a classe condicional) e o comportamento
// é idêntico ao de antes dessa opção existir.
const EnquetePollCard = ({ enquete }) => {
  const encerrada = enquete.status === 'encerrada';
  const temImagem = !!enquete.imagem;
  const temImagemMobile = !!enquete.imagemMobile;
  const imagemUrl = temImagem ? `${API_ORIGIN}${enquete.imagem}` : null;
  const imagemMobileUrl = temImagemMobile ? `${API_ORIGIN}${enquete.imagemMobile}` : null;

  return (
    <div className="relative h-full flex flex-col overflow-hidden rounded-xl shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 bg-white border border-gray-100">
      {temImagemMobile && (
        <div
          className="absolute inset-0 sm:hidden"
          style={{ backgroundImage: `url(${imagemMobileUrl})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
        />
      )}
      {temImagem && (
        <div
          className={`absolute inset-0 ${temImagemMobile ? 'hidden sm:block' : ''}`}
          style={{ backgroundImage: `url(${imagemUrl})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
        />
      )}
      {(temImagem || temImagemMobile) && <div className="absolute inset-0 bg-white/80" />}

      <div className="relative z-10 flex flex-col flex-1 p-6">
        <h3 className="text-xl font-bold text-gray-900 mb-2 text-center">
          {enquete.titulo}
        </h3>

        {enquete.descricao && (
          <p className="text-gray-600 text-sm text-center mb-4 line-clamp-3">
            {enquete.descricao}
          </p>
        )}

        <div className={`p-3 rounded-lg mb-4 ${encerrada ? 'bg-gray-100/90' : 'bg-primary-50/90'}`}>
          {encerrada ? (
            <p className="text-sm text-gray-600 font-medium flex items-center justify-center gap-1.5">
              <CheckCircle2 className="w-4 h-4" /> Consulta encerrada — confira o resultado
            </p>
          ) : (
            <p className="text-sm text-primary-700 font-medium text-center">
              {enquete.total_perguntas} {enquete.total_perguntas === 1 ? 'pergunta' : 'perguntas'}
            </p>
          )}
        </div>

        <Link
          to={enquete.rota}
          className={`mt-auto w-full text-center px-4 py-2.5 font-semibold rounded-lg transition-colors duration-200 ${
            encerrada
              ? 'bg-gray-600 hover:bg-gray-700 text-white'
              : 'btn-primary'
          }`}
        >
          {encerrada ? 'Ver Resultado' : 'Participar da Enquete'}
        </Link>
      </div>
    </div>
  );
};

export default EnquetePollCard;
